export default "__VITE_ASSET__C5PC01E$__"